import {
    getAggregatedOpeningHoursIntervals,
    getLocalizedWeekdayAbbreviation
} from "@/app/features/sites/opening-hours/helper/consecutive-weekdays";
import { DateTime } from "luxon";
import { MutableGeneralOpeningHour } from "@/app/features/sites/opening-hours/model/types";

export function formatOpeningHoursShortText(generalOpeningHours?: MutableGeneralOpeningHour[]) {
    const aggregatedOpeningHoursIntervals = getAggregatedOpeningHoursIntervals(generalOpeningHours || []);

    switch (aggregatedOpeningHoursIntervals.length) {
        case 1:
            const interval = aggregatedOpeningHoursIntervals[0];
            const formattedStartDay = getLocalizedWeekdayAbbreviation(interval.startDay);
            const formattedEndDay = getLocalizedWeekdayAbbreviation(interval.endDay);

            const startTime = DateTime.fromISO(interval.startTime);
            const formattedStartTime = startTime.minute === 0 ? startTime.toFormat("HH") : startTime.toFormat("HH:mm");

            if (interval.endTime) {
                const endTime = DateTime.fromISO(interval.endTime);
                const formattedEndTime = endTime.minute === 0 ? endTime.toFormat("HH") : endTime.toFormat("HH:mm");

                return `Das Museum hat für sie von ${formattedStartDay}\u00A0-\u00A0${formattedEndDay} von\u00A0${formattedStartTime}\u00A0bis\u00A0${formattedEndTime}\u00A0Uhr geöffnet.`;
            } else {
                return `Das Museum hat für sie von ${formattedStartDay}\u00A0-\u00A0${formattedEndDay} ab\u00A0${formattedStartTime}\u00A0Uhr geöffnet.`;
            }

        default:
            return "NOT YET IMPLEMENTED"
    }
}